import React from "react";
import { PageSwapperType } from "../../types";

export default function PageSwapper({
  additionalStyle,
  btns,
  activeBtn,
}: PageSwapperType) {
  return (
    <div
      className={`w-fit flex gap-3 rounded-xl bg-white p-2 ${additionalStyle}`}
    >
      {btns?.map((Btn: any, index) => (
        <div
          key={index}
          className={`${Btn.props.buttonText === activeBtn
              ? "bg-[#0068FF] text-white rounded-xl"
              : ""
            } transition-all duration-300 ease-in-out`}
        >
          {Btn}
        </div>
      ))}
    </div>
  );
}
